/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPencil: {
  name: 'pencil';
  data: string;
} = {
  name: 'pencil',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.414 5a2 2 0 0 0-2.828 0l-2.287 2.287-.006.006a.29.29 0 0 0-.006.006l-6.246 6.246a2 2 0 0 0-.574 1.193l-.323 2.91a2 2 0 0 0 2.209 2.208l2.909-.323a2 2 0 0 0 1.193-.574L19 10.414a2 2 0 0 0 0-2.828l-.707.707.707-.707L16.414 5ZM12 9.414 6.455 14.96l-.323 2.91 2.909-.324L14.586 12 12 9.414Zm4 1.172L17.586 9 15 6.414 13.414 8 16 10.586Z" fill="currentColor"/></svg>`,
};
